export default "__VITE_PUBLIC_ASSET__c55e3912__"